.eg{background:var(--palette-white);}